
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import { CssTextField } from '../../layout/elements';
import { useAuth } from '../../../hooks/useAuth';
import { Box, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';


export default function AccountInfoStep2({userEmail, userPhone, onNext, onBack}) {
    const { authDataLang } = useAuth()
    // const { onNext, onBack, famili, user_name } = props

    const [email, setEmail ] = useState(userEmail)
    const [mobileNumber, setMobileNumber ] = useState(userPhone)
    const [errorMessage, setErrorMessage ] = useState('')

    
    const handleNext = () => {
        const dataRes = {email: email, mobileNumber: mobileNumber}
        console.log(dataRes)
        onNext(dataRes)
    };
    
    const handleBack = () => {
        onBack()
    };

  return (
    
    <Box elevation={3} sx={{  
        bgcolor: 'background.paper', 
        margin: '0.5rem 1rem 0.5rem 0.5rem' }}
        textAlign={'center'}
        >
        <br />
        
        <div style={{textAlign: 'center'}}>
        <Grid container spacing={1} alignItems='flex-end'>
                <Grid item>
                    <LocalPostOfficeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                </Grid>
                <Grid item xs={10}>
                    <CssTextField
                        label={(
                            <Typography 
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                >
                                {/* ایمیل */}
                                {authDataLang?.site_langs?.desc_email}
                            </Typography>
                        )}
                        type='email'
                        fullWidth
                        variant="standard" value={email}
                        onChange={ e => setEmail( e.target.value )} />
                </Grid>
            </Grid>
            <Grid container spacing={1} alignItems='flex-end'>
                <Grid item>
                    <LocalPostOfficeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                </Grid>
                <Grid item xs={10}>
                    <CssTextField 
                        label={(
                            <Typography 
                                fontFamily='b_mitra' 
                                component="div"
                                variant="h6"
                                >
                                {/* تلفن تماس */}
                                {authDataLang?.site_langs?.desc_phone}
                            </Typography>
                        )}
                        fullWidth
                        variant="standard" value={mobileNumber}
                        onChange={ e => setMobileNumber( e.target.value )} />
                </Grid>
            </Grid>

            <br />
            <Divider />
            <br />

            <Grid container spacing={2}>
                <Grid item xs={4} sm={6}>
                    <Button variant="contained" 
                        color="primary" 
                        sx={{paddingLeft: 5, paddingRight: 5}}
                        disabled={!email || !mobileNumber }
                        onClick={handleNext}
                        >
                        <Typography 
                            fontFamily="Segoe UI"
                            component="div"
                            variant="h6"
                            color={"secondry"}
                            >
                            {/* ثبت نام */}
                            {authDataLang?.site_langs?.desc_buttom_accept}
                        </Typography>
                    </Button>
                </Grid>
                <Grid item xs={4} sm={6}>
                    <Button variant="standard" 
                        color="primary" 
                        sx={{paddingLeft: 5, paddingRight: 5}}
                        onClick={handleBack}
                        >
                        <Typography 
                            fontFamily="Segoe UI"
                            component="div"
                            variant="h6"
                            color={"secondry"}
                            >
                            قبلی
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
            {errorMessage &&
                <div>
                    <Divider />
                    <Typography 
                        fontFamily="Segoe UI"
                        component="body"
                        variant="h6"
                        color={"secondry"}
                        >
                        {errorMessage}
                    </Typography>
                </div>
            }
        </div>
    </Box>
    
    );
}
  

AccountInfoStep2.propTypes = {
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    // open: PropTypes.bool.isRequired,
    // famili: PropTypes.string.isRequired,
    // user_name: PropTypes.string.isRequired,
};
  